function Orientation () {
    let response = 'landscape';
    if (window.innerWidth > 0 && window.innerHeight > 0) {
        if (window.innerWidth < window.innerHeight) {
            response = 'portrait';
            return response;
        };
    }
    if (window.matchMedia('(orientation: portrait)').matches) {
        response = 'portrait';
        return response;
    }
    return response;
}

export default Orientation;